<template>
  <div class="receipt-orders">
    <div v-if="Object.keys(myOrders).length === 0">
      <h1 class="section-title" :style="{ color: sectionTitleColorTheme }">
        {{ $t("modal.thereIsNoOrderForTheTable") }} {{ tableQRLabel(tableQR) }}
      </h1>
    </div>

    <div v-if="Object.keys(myOrders).length > 0">
      <h1 class="section-title" :style="{ color: sectionTitleColorTheme }">
        {{ $t("modal.tableOrder") }} {{ tableQRLabel(tableQR) }}
      </h1>
      <template v-for="(order, key) in myOrders">
        <!-- {{myOrders}} -->
        <div class="recent-orders" :key="key">
          <font-awesome-icon
            v-if="isDone(order)"
            icon="check-circle"
            class="done-icon"
          />
          <div ref="content" class="recent-order-content">
            <div class="recent-orders-inside-wrapper">
              <div class="recent-orders-details">
                <span class="date">{{ formatDate(getDate(order)) }}</span>
                <span class="time">
                  {{ formatTime(getDate(order)) }} &nbsp;
                  <span class="recent-orders-qr">{{
                    tableQRLabel(order[0].tableQR)
                  }}</span>
                </span>
              </div>
              <!-- Menu group order Ticket start-->
              <div class="product-type-section">
                <div v-if="getMenuGroupOrder(order).length > 0">
                  <ul
                    class="recent-orders-items-list"
                    v-for="(menugroup, index) in getMenuGroupOrder(order)"
                    :key="`menugroup_${index}`"
                  >
                    <li class="recent-orders-item">
                      <span class="quantity">
                        {{ menugroup.quantity }}
                        <em>x</em>
                      </span>
                      <span class="name text-uppercase">{{
                        translate("order", menugroup)
                      }}</span>
                      <div v-if="menugroup.notes" class="notes">
                        <span>{{ menugroup.notes }}</span>
                      </div>
                      <span class="price">{{
                        formatPrice(menugroup.price * menugroup.quantity)
                      }}</span>
                      <span class="paid-check" v-if="isPaid(menugroup)">
                        <font-awesome-icon
                          icon="check"
                          :style="{ color: '#634e42', fontSize: 20 }"
                        />
                      </span>
                    </li>
                    <li
                      class="order-metadata-title text-uppercase"
                      v-if="menugroup.starters.length > 0"
                    >
                      {{ $t("common.first") }}
                    </li>
                    <li
                      class="recent-orders-item"
                      v-for="food in menugroup.starters"
                      :key="`starter_${food.id}`"
                    >
                      <span class="name">{{ translate("order", food) }}</span>
                      <span class="price">{{
                        formatPrice(food.additional_charge * menugroup.quantity)
                      }}</span>
                    </li>
                    <li
                      class="order-metadata-title text-uppercase"
                      v-if="menugroup.maincourse.length > 0"
                    >
                      {{ $t("common.second") }}
                    </li>
                    <li
                      class="recent-orders-item"
                      v-for="food in menugroup.maincourse"
                      :key="`maincourse_${food.id}`"
                    >
                      <span class="name">{{ translate("order", food) }}</span>
                      <span class="price">{{
                        formatPrice(food.additional_charge * menugroup.quantity)
                      }}</span>
                    </li>
                    <li
                      class="order-metadata-title text-uppercase"
                      v-if="menugroup.desserts.length > 0"
                    >
                      {{ $t("common.dessert") }}
                    </li>
                    <li
                      class="recent-orders-item"
                      v-for="dessert in menugroup.desserts"
                      :key="`dessert_${dessert.id}`"
                    >
                      <span class="name">{{
                        translate("order", dessert)
                      }}</span>
                      <span class="price">{{
                        formatPrice(
                          dessert.additional_charge * menugroup.quantity
                        )
                      }}</span>
                    </li>
                    <li
                      class="order-metadata-title"
                      v-if="menugroup.drinks.length > 0"
                    >
                      {{ $t("common.drinks") }}
                    </li>
                    <li
                      class="recent-orders-item"
                      v-for="drink in menugroup.drinks"
                      :key="`drink_${drink.id}`"
                    >
                      <span class="name">{{ translate("order", drink) }}</span>
                      <span class="price">{{
                        formatPrice(
                          drink.additional_charge * menugroup.quantity
                        )
                      }}</span>
                    </li>

                    <li
                      class="recent-orders-item"
                      v-if="menugroup.selectOption === 'invitation'"
                    >
                      <div class="invitation-header">
                        <h3 class="recent-orders-product-type">
                          {{ $t("modal.invitation") }}
                        </h3>
                      </div>
                      <span class="quantity">
                        {{ menugroup.removeQuantity }}
                        <em>x</em>
                      </span>
                      <span class="name">{{
                        translate("order", menugroup)
                      }}</span>
                      <span class="price">
                        -
                        {{
                          formatPrice(
                            menugroup.price * menugroup.removeQuantity +
                              totalWithAdditionalCharge(menugroup)
                          )
                        }}</span
                      >
                    </li>
                  </ul>
                </div>
                <!-- Menu group order Ticket End-->
                <div v-if="getCartDrinks(order).length > 0">
                  <h3 class="recent-orders-product-type">
                    {{ $t("common.drinks") }}
                  </h3>
                  <ul class="recent-orders-items-list">
                    <li
                      class="recent-orders-item"
                      v-for="(drink, index) in getCartDrinks(order)"
                      :key="`drink_${index}`"
                    >
                      <span class="quantity">
                        {{ drink.quantity }}
                        <em>x</em>
                      </span>
                      <span class="name">{{ translate("order", drink) }}</span>
                      <span class="size">{{ sizeText(drink) }}</span>
                      <div v-if="drink.notes" class="notes">
                        <span>{{ drink.notes }}</span>
                      </div>
                      <span class="price">{{
                        formatPrice(drink.price * drink.quantity)
                      }}</span>
                      <span class="paid-check" v-if="isPaid(drink)">
                        <font-awesome-icon
                          icon="check"
                          :style="{ color: '#634e42', fontSize: 20 }"
                        />
                      </span>
                    </li>
                  </ul>
                </div>

                <template v-if="getCartDrinks(order).length > 0">
                  <ul
                    class="recent-orders-items-list"
                    v-if="getCartDrinks(order).length > 0"
                  >
                    <li
                      class="recent-orders-item"
                      v-for="(drink, index) in getCartDrinks(order)"
                      :key="`drink_${index}`"
                    >
                      <template v-if="drink.selectOption === 'invitation'">
                        <div class="invitation-header">
                          <h3 class="recent-orders-product-type">
                            {{ $t("modal.invitation") }}
                          </h3>
                        </div>
                        <span class="quantity">
                          {{ drink.removeQuantity }}
                          <em>x</em>
                        </span>
                        <span class="name">{{
                          translate("order", drink)
                        }}</span>
                        <span class="price"
                          >-
                          {{
                            formatPrice(drink.price * drink.removeQuantity)
                          }}</span
                        >
                        <span class="paid-check" v-if="isPaid(drink)">
                          <font-awesome-icon
                            icon="check"
                            :style="{ color: '#634e42', fontSize: 20 }"
                          />
                        </span>
                      </template>
                    </li>
                  </ul>
                </template>

                <div v-if="getCartDessert(order).length > 0">
                  <h3 class="recent-orders-product-type">Postre</h3>
                  <ul class="recent-orders-items-list">
                    <li
                      class="recent-orders-item"
                      v-for="(dessert, index) in getCartDessert(order)"
                      :key="`drink_${index}`"
                    >
                      <span class="quantity">
                        {{ dessert.quantity }}
                        <em>x</em>
                      </span>
                      <span class="name">{{
                        translate("order", dessert)
                      }}</span>
                      <span class="size">{{ sizeText(dessert) }}</span>
                      <div v-if="dessert.notes" class="notes">
                        <span>{{ dessert.notes }}</span>
                      </div>
                      <span class="price">{{
                        formatPrice(dessert.price * dessert.quantity)
                      }}</span>
                      <span class="paid-check" v-if="isPaid(dessert)">
                        <font-awesome-icon
                          icon="check"
                          :style="{ color: '#634e42', fontSize: 20 }"
                        />
                      </span>
                    </li>
                  </ul>
                </div>

                <template v-if="getCartDessert(order).length > 0">
                  <ul
                    class="recent-orders-items-list"
                    v-if="getCartDessert(order).length > 0"
                  >
                    <li
                      class="recent-orders-item"
                      v-for="(dessert, index) in getCartDessert(order)"
                      :key="`drink_${index}`"
                      :style="{
                        display:
                          dessert.selectOption === 'invitation'
                            ? 'grid'
                            : 'none'
                      }"
                    >
                      <template v-if="dessert.selectOption === 'invitation'">
                        <div class="invitation-header">
                          <h3 class="recent-orders-product-type">
                            {{ $t("modal.invitation") }}
                          </h3>
                        </div>
                        <span class="quantity">
                          {{ dessert.removeQuantity }}
                          <em>x</em>
                        </span>
                        <span class="name">{{
                          translate("order", dessert)
                        }}</span>
                        <span class="price"
                          >-
                          {{
                            formatPrice(dessert.price * dessert.removeQuantity)
                          }}</span
                        >
                      </template>
                    </li>
                  </ul>
                </template>

                <div v-if="hasFoodTypeOrder(order)">
                  <h3 class="recent-orders-product-type">
                    {{ $t("common.food") }}
                  </h3>
                  <ul class="recent-orders-items-list">
                    <li
                      class="recent-orders-item"
                      v-for="food in getCartFood(order)"
                      :key="`food_${food.id}`"
                    >
                      <span class="quantity">
                        {{ food.quantity }}
                        <em>x</em>
                      </span>
                      <span class="name">{{ translate("order", food) }}</span>
                      <div v-if="food.notes" class="notes">
                        <span>{{ food.notes }}</span>
                      </div>
                      <span class="price">{{
                        weight(food) + formatPrice(food.price * food.quantity)
                      }}</span>
                      <span class="paid-check" v-if="isPaid(food)">
                        <font-awesome-icon
                          icon="check"
                          :style="{ color: '#634e42', fontSize: 20 }"
                        />
                      </span>
                    </li>
                    <li
                      class="order-metadata-title"
                      v-if="getCartFoodShared(order).length"
                    >
                      {{ shareLabel }}
                    </li>
                    <li
                      class="recent-orders-item"
                      v-for="food in getCartFoodShared(order)"
                      :key="`food_${food.id}`"
                    >
                      <span class="quantity">
                        {{ food.quantity }}
                        <em>x</em>
                      </span>
                      <span class="name">{{ translate("order", food) }}</span>
                      <div v-if="food.notes" class="notes">
                        <span>{{ food.notes }}</span>
                      </div>
                      <span class="price">{{
                        formatPrice(food.price * food.quantity)
                      }}</span>
                      <span class="paid-check" v-if="isPaid(food)">
                        <font-awesome-icon
                          icon="check"
                          :style="{ color: '#634e42', fontSize: 20 }"
                        />
                      </span>
                    </li>
                    <li
                      class="order-metadata-title"
                      v-if="getCartFoodMainCourse(order).length"
                    >
                      {{ $t("common.mainCourses") }}
                    </li>
                    <li
                      class="recent-orders-item"
                      v-for="food in getCartFoodMainCourse(order)"
                      :key="`food_${food.id}`"
                    >
                      <span class="quantity">
                        {{ food.quantity }}
                        <em>x</em>
                      </span>
                      <span class="name">{{ translate("order", food) }}</span>
                      <div v-if="food.notes" class="notes">
                        <span>{{ food.notes }}</span>
                      </div>
                      <span class="price">{{
                        formatPrice(food.price * food.quantity)
                      }}</span>
                      <span class="paid-check" v-if="isPaid(food)">
                        <font-awesome-icon
                          icon="check"
                          :style="{ color: '#634e42', fontSize: 20 }"
                        />
                      </span>
                    </li>
                  </ul>
                </div>

                <template v-if="hasFoodTypeOrder(order)">
                  <ul class="recent-orders-items-list">
                    <li
                      class="recent-orders-item"
                      v-for="food in getCartFood(order)"
                      :key="`food_${food.id}`"
                      :style="{
                        display:
                          food.selectOption === 'invitation' ? 'grid' : 'none'
                      }"
                    >
                      <template v-if="food.selectOption === 'invitation'">
                        <div class="invitation-header">
                          <h3 class="recent-orders-product-type">
                            {{ $t("modal.invitation") }}
                          </h3>
                        </div>
                        <span class="quantity">
                          {{ food.removeQuantity }}
                          <em>x</em>
                        </span>
                        <span class="name">{{ translate("order", food) }}</span>
                        <span class="price">{{
                          formatPrice(food.price * food.removeQuantity)
                        }}</span>
                      </template>
                    </li>

                    <li
                      class="recent-orders-item"
                      v-for="food in getCartFoodMainCourse(order)"
                      :key="`food_${food.id}`"
                      :style="{
                        display:
                          food.selectOption === 'invitation' ? 'grid' : 'none'
                      }"
                    >
                      <template v-if="food.selectOption === 'invitation'">
                        <div class="invitation-header">
                          <h3 class="recent-orders-product-type">
                            {{ $t("modal.invitation") }}
                          </h3>
                        </div>
                        <span class="quantity">
                          {{ food.removeQuantity }} <em>x</em>
                        </span>
                        <span class="name">{{ translate("order", food) }}</span>
                        <span class="price">
                          -
                          {{
                            formatPrice(food.price * food.removeQuantity)
                          }}</span
                        >
                      </template>
                    </li>

                    <li
                      class="recent-orders-item"
                      v-for="food in getCartFoodShared(order)"
                      :key="`food_${food.id}`"
                      :style="{
                        display:
                          food.selectOption === 'invitation' ? 'grid' : 'none'
                      }"
                    >
                      <template v-if="food.selectOption === 'invitation'">
                        <div class="invitation-header">
                          <h3 class="recent-orders-product-type">
                            {{ $t("modal.invitation") }}
                          </h3>
                        </div>
                        <span class="quantity">
                          {{ food.removeQuantity }}
                          <em>x</em>
                        </span>
                        <span class="name">{{ translate("order", food) }}</span>
                        <span class="price">
                          -
                          {{
                            formatPrice(food.price * food.removeQuantity)
                          }}</span
                        >
                      </template>
                    </li>
                  </ul>
                </template>

                <div class="total-price">
                  <span class="label">Total:</span>
                  <span class="total-price-value">{{
                    formatPrice(
                      getTotalPrice(order) - getInvitationTotalPrice(order)
                    )
                  }}</span>
                </div>
                <div
                  class="expandable-row"
                  v-if="myComments[key] && myComments[key].length > 0"
                >
                  <div class="table-cell">
                    <div class="general-notes">{{ $t("common.comments") }}</div>
                    <div class="general-desc">
                      {{ myComments[key][0].comment }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <v-footer fixed height="70px" class="home">
      <v-container class="pa-0">
        <v-row class="mx-0 footer-row">
          <v-col class="d-flex justify-start price-title pa-0"
            >{{ $t("payment.missingPay") }}
          </v-col>
          <v-col class="d-flex justify-center price-title pa-0">
            {{ formatPrice(getUnpaidTotalPrice) }}
          </v-col>
          <v-col class="d-flex justify-end pa-0">
            <button
              :class="`checkout-button ${!getUnpaidTotalPrice && 'disabled'}`"
              :style="[
                { 'border-radius': buttonBorderRadiusTheme },
                { color: colorsGeneralPrimary },
                { borderColor: colorsGeneralPrimary }
              ]"
              @click="open = true"
              :disabled="!getUnpaidTotalPrice"
            >
              <span>{{ $t("payment.pay") }}</span>
            </button>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <product-chooser-dialog
      :open.sync="open"
      :unpaid-total-price="getUnpaidTotalPrice"
      :total-price-all-orders="getTotalPriceOfAllOrders"
    ></product-chooser-dialog>
  </div>
</template>

<script>
import ProductChooserDialog from "@/components/public/receipt/ProductChooserDialog";
import { ordersCollection } from "@/collections/orders";
import { ordersTotalByTableCollection } from "@/collections/ordersTotalByTable";
import { orderCommentsCollection } from "@/collections/orderComments";

export default {
  name: "recepts-orders",
  components: {
    ProductChooserDialog
  },
  data() {
    return {
      open: false,
      ordersCollection: [],
      orderComments: [],
      ordersTotalByTable: []
    };
  },
  firestore() {
    return {
      ordersCollection: ordersCollection
        .where("tableQR", "==", this.tableQR)
        .where("isOpen", "==", true)
        .orderBy("time", "desc"),
      orderComments: orderCommentsCollection.where(
        "tableQR",
        "==",
        this.tableQR
      ),
      ordersTotalByTable: ordersTotalByTableCollection.where(
        "tableQR",
        "==",
        this.tableQR
      )
    };
  },
  computed: {
    myOrders() {
      let orders = this.ordersCollection.filter(x => x.metadata);
      return this.arrayGroupBy(orders, "time");
    },
    myComments() {
      return this.arrayGroupBy(this.orderComments, "time");
    },
    tableQR() {
      let tableQR = localStorage.getItem("tableQR");
      return this.$store.state.tableQR || tableQR;
    },
    getUnpaidTotalPrice() {
      let orderByTable = this.ordersTotalByTable.find(
        x => x.tableQR === this.tableQR
      );
      return parseFloat((orderByTable ? orderByTable.remaining : 0).toFixed(2));
    },
    getTotalPriceOfAllOrders() {
      let total = 0;
      let orders = this.ordersCollection.filter(
        order => order.isOpen && order.metadata
      );
      if (orders.length > 0) {
        orders.forEach(order => {
          total +=
            order.quantity * order.price +
            this.totalWithAdditionalCharge(order);
        });
      }
      return total;
    },
    shareLabel() {
      return process.env.VUE_APP_SHOW_SHARE_LABEL === "true"
        ? this.$t("common.toShare")
        : this.$t("common.first");
    }
  },
  async mounted() {
    let self = this;
    self.$store.commit("setMyOrderQuantity", 0);
    localStorage.setItem("myordersQuantity", 0);
  },
  methods: {
    weight(order) {
      return order.weight ? order.weight + "Kg \xa0\xa0" : " ";
    },
    isPaid(order) {
      let isPaid = true;

      // eslint-disable-next-line no-unused-vars
      for (const [quantity, metadata] of Object.entries(order.metadata)) {
        if (!metadata.isPaid) {
          isPaid = false;
        }
      }
      return isPaid;
    },
    isDone(orders) {
      let isDone = true;
      // eslint-disable-next-line no-unused-vars
      orders.forEach((item, index) => {
        if (item.isPending) {
          isDone = false;
        }
      });

      return isDone;
    },
    // eslint-disable-next-line no-unused-vars
    getDate(order, key) {
      return order.length > 0 ? order[0].time : undefined;
    },
    getCartDrinks(order) {
      const { drinks } = this.$store.state.productTypeIds;
      return order.filter(
        item => item.product_type_id === drinks && item.metadata
      );
    },
    getCartDessert(order) {
      const { dessert } = this.$store.state.productTypeIds;
      return order.filter(
        item => item.product_type_id === dessert && item.metadata
      );
    },
    getCartFoodShared(orders) {
      const { food } = this.$store.state.productTypeIds;

      return orders.filter(
        x =>
          x.product_type_id === food && x.metadata && (x.canBeShared || false)
      );
    },
    getCartFoodMainCourse(orders) {
      const { food } = this.$store.state.productTypeIds;

      return orders.filter(
        x =>
          (x.product_type_id === food &&
            x.metadata &&
            !x.canBeShared &&
            x.canBeMainCourse) ||
          false
      );
    },
    hasFoodTypeOrder(order) {
      const { food } = this.$store.state.productTypeIds;
      return order.find(x => x.product_type_id === food);
    },
    getCartFood(order) {
      const { food } = this.$store.state.productTypeIds;
      return order.filter(
        x =>
          x.product_type_id === food &&
          x.metadata &&
          !x.canBeShared &&
          !x.canBeMainCourse
      );
    },
    getInvitationTotalPrice(order) {
      let total = 0;
      order.forEach(item => {
        if (item.selectOption === "invitation") {
          total +=
            item.removeQuantity * item.price +
            this.totalWithAdditionalCharge(item);
        }
      });
      return total;
    },
    getMenuGroupOrder(order) {
      return order.filter(item => {
        if (item.isMenuGroupProduct) {
          return item;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.footer-row {
  align-items: center;
}

.section-title {
  text-transform: uppercase;
  font-size: 14px;
  text-align: center;
  letter-spacing: 3px;
  padding-top: 20px;
}

.receipt-orders {
  height: 100%;
  margin-bottom: 80px;

  .order-metadata-title {
    padding-top: 10px;
    font-weight: 600;
  }
}

@media screen and (max-width: 320px) {
  .receipt-view .price-title {
    font-size: 15px;
  }
}
</style>
